import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { DataSubmissionConfiguration } from "../../../../api/types/dataCollectionTypes";
import type { ObjectAccessCategory, ObjectClassDefinition } from "../../../../api/types/objectTypes";

interface Props {
  categories: ObjectAccessCategory[];
  onCategoriesUpdated: (categories: ObjectAccessCategory[]) => void;
  configurations: DataSubmissionConfiguration[];
  objectDefinition: ObjectClassDefinition;
  hasPermissionsToManage: boolean;
}

const DataRequestSetupPageContext = createContext<Props | undefined>(undefined);

export const DataRequestSetupPageContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <DataRequestSetupPageContext value={contextValue}>{children}</DataRequestSetupPageContext>
);

export default DataRequestSetupPageContext;
